import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lohi-number-badge',
  templateUrl: './number-badge.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberBadgeComponent implements OnInit {
  @Input() public count = 0;
  @Input() public bgClass = 'bg-red-500';
  @Input() public showIfZero = false;
  @Input() public currency = false;

  constructor() {}

  public ngOnInit(): void {}
}
